import ajax from "./ajax";

export function getMenu() {
 return ajax(`Menu/index?sort=display_order&per-page=1000`);
}
